import * as React from "react"
const Rear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_3"
    width={"100%"}
    height={"100%"}
    x={0}
    y={0}
    style={{
      maxHeight: 500,
    }}
    viewBox="55.533 6.81 24.7 47.213"
    {...props}
  >
    <style>
      {
        `.st0,.st1{fill:none;stroke:${props.color};stroke-width:.6;stroke-linecap:round;stroke-linejoin:round}.st1{stroke-miterlimit:4.0005}`
      }
    </style>
    <path
      d="M69.8 12.5h-5.5l-1.2.1-3.2 1.6-2.1 3.3-.2 1.3.3 1.2.9 1.1.9 1.2.8 2.7"
      className="st0"
    />
    <circle cx={64.9} cy={18.2} r={1.5} className="st0" />
    <circle cx={68.5} cy={18.2} r={1.5} className="st0" />
    <path
      d="m72.5 27.6 1.4-4L74 22l1.7-1.8.3-.8v-1.5l-.3-1.3-.9-1.2-1.6-1.8-3.4-1.1M62.7 51c0 1.3 1.9 2.3 4.2 2.3 2.2 0 4.2-1.1 4.2-2.3M72.5 10.7c0-1.7-2.6-3.1-5.8-3.1-3.2 0-5.7 1.3-5.8 3"
      className="st0"
    />
    <ellipse
      cx={55.8}
      cy={16.2}
      className="st1"
      rx={0.2}
      ry={0.4}
      transform="rotate(-28.598 55.788 16.182)"
    />
    <path
      d="m56 16.1.8-.3M55.7 15.9l.8-.3M56 16.6l.8-.4M56.4 15.6c.1 0 .2 0 .3.2.1.1.1.4 0 .4h0M56.5 15.6l3.6-1.5M56.8 16.2l2.5-1.1"
      className="st0"
    />
    <ellipse
      cx={78.4}
      cy={16.3}
      className="st1"
      rx={0.4}
      ry={0.2}
      transform="rotate(-61.399 78.373 16.345)"
    />
    <path
      d="m78.1 16.3-.8-.3M78.5 16l-.9-.3M78.1 16.7l-.8-.4M77.7 15.7c-.1 0-.2 0-.3.2-.1.1-.1.4 0 .4h0M77.6 15.7l-3.5-1.5M77.3 16.3l-2.5-.9M64.5 26.4c-1.1.4-1.7 1.1-1.7 1.9M71 28.2c0-.8-.8-1.6-2-2M71 28.2V51M62.7 28.2V51M62.3 44.9v-7.7M61.2 37.2h1.1M59.5 26.2l-.7.8v-1.7l.2-.2h-1.1"
      className="st0"
    />
    <path
      d="m57.9 25.1.3.4v1.9l-.6.1v.5l.3.2v1.3l.7.7M58.6 30.2c-.5.7-.6 2.1-.3 3.2.2.6.5 1 .9 1M59.2 34.4v.1h-3.3v.3l2.8.5v.5l1.4.2M59.5 26.2l1-1.2M60.1 41.1l.5.8h.6v-4.7M60.1 36v5.1M60.1 36.8h-1.5v.9h.7l.8 1M70.6 24.1h-7.9V21h7.9v3.1M71.2 45.6l.4-.6h.5v-.3h.2v-.6h-.2v-1.4H71M71.2 45.6H71M71.5 42.7v-.8h.8v-2.3H72v.7h-.4v1.1H71M72.4 38.9v.7"
      className="st0"
    />
    <path
      d="M72.3 40.8h1.2v-1.4l1.1-.9M71.9 9.3l-2.3 2.9M61.7 9.1l2.2 3.4M60.9 10.7v.2l.3.3v.5l-1.8 2.1v.5M72.5 10.7l-.4.5v.4l1.8 2.3v.3M73.9 28.8c.1 1.3 1.5 2.2 3.2 2.1 1.3-.1 2.4-1 2.6-2.1"
      className="st0"
    />
    <path
      d="M75.8 26.7c-1.5.5-2.2 1.8-1.7 3.2.5 1.2 2.1 1.9 3.7 1.4 1.5-.5 2.2-1.8 1.7-3.2-.3-.6-.9-1.1-1.6-1.4-.9-.1-1.5-.1-2.1 0M73.5 32.3c-.3 1.3.6 2.7 2.1 2.9 1.5.2 3.2-.5 3.5-1.9v-.5"
      className="st0"
    />
    <path
      d="M73.2 34.7c.2 1.3 1.7 2.1 3.3 2 1.4-.2 2.4-1.2 2.4-2.4"
      className="st0"
    />
    <path
      d="M73.1 35.7c-.3 1.3.6 2.7 2.1 2.9 1.5.3 3.1-.6 3.4-1.9v-.4M79.5 29.8l-.7 6.8M73.8 29.3l-.8 6.8"
      className="st0"
    />
    <path
      d="m73.6 37.5-.9 1.2h-.3M73.6 29.1l-.7-.7-.7-.8v-1.3"
      className="st0"
    />
    <path d="M72.2 26.3h-.6v2.5l2 1.6" className="st0" />
    <ellipse cx={76.7} cy={28.8} className="st0" rx={1.4} ry={1.1} />
    <path
      d="M76.9 28.8c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2z"
      className="st0"
    />
    <circle cx={78.6} cy={28.1} r={0.1} className="st0" />
    <circle cx={78.9} cy={29} r={0.1} className="st0" />
    <circle cx={77.9} cy={30.1} r={0.1} className="st0" />
    <circle cx={76.6} cy={30.4} r={0.1} className="st0" />
    <circle cx={75.3} cy={30} r={0.1} className="st0" />
    <circle cx={74.7} cy={28.9} r={0.1} className="st0" />
    <circle cx={75.1} cy={27.8} r={0.1} className="st0" />
    <circle cx={76.1} cy={27.2} r={0.1} className="st0" />
    <circle cx={77.7} cy={27.3} r={0.1} className="st0" />
    <path
      d="M69.1 26.3c-.5-.3-1.4-.5-2.2-.5-.9 0-1.8.2-2.3.6"
      className="st0"
    />
  </svg>
)
export default Rear
